// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=9cd165b9-3d07-4dcf-a9ac-5b756721230e";
};